export interface MovementPatternDtlEntity {
    id?: number | null,
    tempKey?: string | null,
    seq?: number | null,
    tempSeq?: number | null,
    movementPatternId?: number | null,
    cntrStatus?: string | null,
    movementCode?: string | null,
    fromOtChargeInd?: string | null,
    toOtChargeInd?: string | null,

    [key: string]: string | boolean | null | Object | undefined
}

export const EMPTY_MOVEMENT_PATTERN_DTL_ENTITY: MovementPatternDtlEntity = {

    id: null,
    tempKey: null,
    seq: null,
    tempSeq: null,
    movementPatternId: null,
    cntrStatus: '',
    movementCode: '',
    fromOtChargeInd: 'N',
    toOtChargeInd: 'N',
}